import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function MumbaiToMahabaleshwarCab() {



    const cardData = {




keyword: "Mumbai to Mahabaleshwar Cab",

headingDescription: "Shreesha Tours & Travels offers reliable and affordable Mumbai to Mahabaleshwar cab services for families, couples, business travelers, tourists, and weekend holiday seekers. We provide one-way cabs, round-trip taxi services, and customized outstation travel packages with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury cars suitable for solo travelers, families, and groups. With doorstep pickup anywhere in Mumbai, flexible departure timings, transparent pricing, easy booking, and 24/7 customer support, we ensure a comfortable and hassle-free journey. Whether you are planning a relaxing hill station vacation, honeymoon, corporate outing, family holiday, or sightseeing tour, Shreesha Tours & Travels delivers safe, punctual, and comfortable travel from Mumbai to Mahabaleshwar with professional drivers and quality service.",

topPlaces: [
  {
    title: "Venna Lake",
    description: "Venna Lake is one of Mahabaleshwar's most popular tourist attractions, offering boating, horse riding, local food stalls, and beautiful natural surroundings. It is a favorite destination for families, couples, and children looking to enjoy a peaceful outing amidst the hills."
  },
  {
    title: "Arthur's Seat",
    description: "Arthur's Seat is a famous viewpoint known as the 'Queen of all Points' in Mahabaleshwar. It offers breathtaking panoramic views of deep valleys, lush green mountains, and the Savitri River, making it a must-visit destination for nature lovers and photographers."
  },
  {
    title: "Mapro Garden",
    description: "Mapro Garden is a popular tourist attraction famous for fresh strawberries, fruit products, chocolates, sandwiches, and beautiful garden surroundings. Visitors enjoy shopping, delicious food, and family-friendly experiences throughout the year."
  },
  {
    title: "Elephant's Head Point",
    description: "Elephant's Head Point is well known for its naturally formed rock resembling an elephant's head. The viewpoint provides spectacular views of the Western Ghats and is one of the best locations for photography and sightseeing."
  },
  {
    title: "Wilson Point",
    description: "Wilson Point is the highest point in Mahabaleshwar and is famous for offering magnificent sunrise views. Visitors enjoy cool weather, scenic landscapes, and panoramic views from multiple observation points."
  },
  {
    title: "Pratapgad Fort",
    description: "Pratapgad Fort is a historic Maratha fort associated with Chhatrapati Shivaji Maharaj. The fort offers impressive architecture, historical significance, scenic viewpoints, and attracts history enthusiasts from across the country."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a beautiful hill station located close to Mahabaleshwar, known for Table Land, Sydney Point, Parsi Point, boarding schools, and pleasant weather. Many travelers combine both destinations in a single holiday trip."
  },
  {
    title: "Tapola",
    description: "Tapola is popularly known as the 'Mini Kashmir of Maharashtra' because of its beautiful backwaters, boating activities, green valleys, and peaceful surroundings. It is an ideal destination for adventure lovers and families."
  },
  {
    title: "Lingmala Waterfall",
    description: "Lingmala Waterfall is one of the most scenic waterfalls in Mahabaleshwar, especially during the monsoon season. The lush greenery and refreshing atmosphere make it a favorite attraction for nature lovers."
  },
  {
    title: "Kaas Plateau",
    description: "Kaas Plateau, a UNESCO World Natural Heritage Site, is famous for its seasonal wildflowers and breathtaking natural beauty. Located near Mahabaleshwar, it attracts photographers, botanists, and tourists seeking a unique nature experience."
  }
],




"services": [
  {
    "name": "Mumbai to Mahabaleshwar Cab",
    "description": "Book Mumbai to Mahabaleshwar Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, and SUV cabs for family trips, holiday tours, business travel, and one way or round trip journeys."
  },
  {
    "name": "Mumbai to Mahabaleshwar Taxi",
    "description": "Hire Mumbai to Mahabaleshwar Taxi for convenient intercity travel with experienced drivers, transparent pricing, and comfortable vehicles. Enjoy reliable one way and round trip taxi services."
  },
  {
    "name": "Mumbai to Mahabaleshwar Taxi Fare",
    "description": "Check Mumbai to Mahabaleshwar Taxi Fare with affordable pricing, no hidden charges, and flexible packages. Get comfortable cabs with professional drivers for your journey."
  },
  {
    "name": "Car from Mumbai to Mahabaleshwar",
    "description": "Book Car from Mumbai to Mahabaleshwar for hassle-free travel with clean AC vehicles, experienced chauffeurs, and flexible pickup and drop services."
  },
  {
    "name": "Cab Service from Mumbai to Mahabaleshwar",
    "description": "Choose Cab Service from Mumbai to Mahabaleshwar for reliable transportation with premium vehicles, professional drivers, and affordable travel packages."
  },
  {
    "name": "Cab Fare from Mumbai to Mahabaleshwar",
    "description": "Get the best Cab Fare from Mumbai to Mahabaleshwar with transparent pricing, quality service, and multiple vehicle options for every travel requirement."
  },
  {
    "name": "Car Hire from Mumbai to Mahabaleshwar",
    "description": "Hire Car from Mumbai to Mahabaleshwar with chauffeur-driven vehicles for family vacations, sightseeing, weekend trips, and business travel."
  },
  {
    "name": "Mumbai Mahabaleshwar Taxi Hire",
    "description": "Reserve Mumbai Mahabaleshwar Taxi Hire for comfortable travel with spacious vehicles, skilled drivers, and flexible travel schedules."
  },
  {
    "name": "Mumbai to Mahabaleshwar Cab Booking",
    "description": "Complete Mumbai to Mahabaleshwar Cab Booking online with instant confirmation and multiple vehicle choices including Sedan, Ertiga, Innova Crysta, and SUVs."
  },
  {
    "name": "Mumbai to Mahabaleshwar Cab Service",
    "description": "Book Mumbai to Mahabaleshwar Cab Service for dependable long-distance travel with professional chauffeurs, clean vehicles, and affordable fares."
  },
  {
    "name": "Mumbai to Mahabaleshwar Car Hire",
    "description": "Choose Mumbai to Mahabaleshwar Car Hire for private chauffeur-driven travel with comfortable seating and reliable transportation."
  },
  {
    "name": "Mumbai to Mahabaleshwar Car Rental",
    "description": "Reserve Mumbai to Mahabaleshwar Car Rental with premium vehicles, flexible rental options, and experienced drivers for a smooth journey."
  },
  {
    "name": "Mumbai to Mahabaleshwar Car Rental Price",
    "description": "Check Mumbai to Mahabaleshwar Car Rental Price for affordable rates and quality cab services with no hidden charges."
  },
  {
    "name": "Mumbai to Mahabaleshwar One Way Taxi",
    "description": "Book Mumbai to Mahabaleshwar One Way Taxi for economical single-trip travel with fixed pricing and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Taxi for Mahabaleshwar from Mumbai",
    "description": "Hire Taxi for Mahabaleshwar from Mumbai for safe and comfortable travel with professional drivers and premium AC vehicles."
  },
  {
    "name": "Mumbai to Panchgani Cab",
    "description": "Book Mumbai to Panchgani Cab for convenient hill station travel with reliable drivers, spacious vehicles, and affordable packages."
  },
  {
    "name": "Mumbai to Panchgani Cab Fare",
    "description": "Check Mumbai to Panchgani Cab Fare with transparent pricing and budget-friendly travel options for one way and round trips."
  },
  {
    "name": "Mumbai to Panchgani Car Rental",
    "description": "Reserve Mumbai to Panchgani Car Rental with comfortable AC vehicles, experienced chauffeurs, and flexible travel schedules."
  },
  {
    "name": "Mumbai to Panchgani Taxi",
    "description": "Choose Mumbai to Panchgani Taxi for smooth intercity travel with professional drivers and multiple vehicle options."
  },
  {
    "name": "Mumbai to Panchgani Taxi Fare",
    "description": "Get Mumbai to Panchgani Taxi Fare with competitive pricing and reliable taxi services for comfortable family and business travel."
  },
  {
    "name": "Mumbai to Tapola Cab",
    "description": "Book Mumbai to Tapola Cab for comfortable sightseeing and holiday travel with well-maintained vehicles and experienced chauffeurs."
  },
  {
    "name": "Mumbai Airport to Mahabaleshwar Taxi",
    "description": "Hire Mumbai Airport to Mahabaleshwar Taxi for timely airport pickup and comfortable travel with professional drivers and premium vehicles."
  },
  {
    "name": "Mumbai Airport to Mahabaleshwar Cab",
    "description": "Reserve Mumbai Airport to Mahabaleshwar Cab with doorstep airport pickup, clean AC cars, and affordable travel packages."
  },
  {
    "name": "Mumbai to Kolhapur Cab",
    "description": "Book Mumbai to Kolhapur Cab for reliable interstate travel with Sedan, Ertiga, Innova Crysta, and SUV options for family and corporate trips."
  },
  {
    "name": "Mumbai Airport to Kolhapur Cab",
    "description": "Choose Mumbai Airport to Kolhapur Cab for direct airport transfers with professional chauffeurs and comfortable long-distance travel."
  },
  {
    "name": "Mumbai Kolhapur Cab Service",
    "description": "Hire Mumbai Kolhapur Cab Service for safe and affordable travel with experienced drivers and well-maintained AC vehicles."
  },
  {
    "name": "Mumbai to Kolhapur Car Rental",
    "description": "Book Mumbai to Kolhapur Car Rental for chauffeur-driven travel with flexible one way and round trip options."
  },
  {
    "name": "Mumbai to Satara Cab",
    "description": "Reserve Mumbai to Satara Cab for smooth outstation travel with comfortable vehicles, professional drivers, and competitive pricing."
  },
  {
    "name": "Mumbai to Sangli Car Rental",
    "description": "Choose Mumbai to Sangli Car Rental for premium chauffeur-driven vehicles, affordable fares, and reliable long-distance transportation."
  },
  {
    "name": "Mumbai to Sangli Cab",
    "description": "Book Mumbai to Sangli Cab for safe and comfortable travel with experienced chauffeurs, clean vehicles, and flexible booking options."
  }
],
"tableData": [
  ["Mumbai to Mahabaleshwar Cab", "Mumbai to Mahabaleshwar Taxi"],
  ["Mumbai to Mahabaleshwar Taxi Fare", "Car from Mumbai to Mahabaleshwar"],
  ["Cab Service from Mumbai to Mahabaleshwar", "Cab Fare from Mumbai to Mahabaleshwar"],
  ["Car Hire from Mumbai to Mahabaleshwar", "Mumbai Mahabaleshwar Taxi Hire"],
  ["Mumbai to Mahabaleshwar Cab Booking", "Mumbai to Mahabaleshwar Cab Service"],
  ["Mumbai to Mahabaleshwar Car Hire", "Mumbai to Mahabaleshwar Car Rental"],
  ["Mumbai to Mahabaleshwar Car Rental Price", "Mumbai to Mahabaleshwar One Way Taxi"],
  ["Taxi for Mahabaleshwar from Mumbai", "Mumbai to Panchgani Cab"],
  ["Mumbai to Panchgani Cab Fare", "Mumbai to Panchgani Car Rental"],
  ["Mumbai to Panchgani Taxi", "Mumbai to Panchgani Taxi Fare"],
  ["Mumbai to Tapola Cab", "Mumbai Airport to Mahabaleshwar Taxi"],
  ["Mumbai Airport to Mahabaleshwar Cab", "Mumbai to Kolhapur Cab"],
  ["Mumbai Airport to Kolhapur Cab", "Mumbai Kolhapur Cab Service"],
  ["Mumbai to Kolhapur Car Rental", "Mumbai to Satara Cab"],
  ["Mumbai to Sangli Car Rental", "Mumbai to Sangli Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Mahabaleshwar Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels offers reliable Mumbai to Mahabaleshwar cab services with clean vehicles, professional chauffeurs, and comfortable travel for families, couples, corporate travellers, and tourists."
  },
  {
    WhyChooseheading: "Perfect for Weekend & Holiday Trips",
    WhyChoosedescription: "Escape the city's hustle with a relaxing drive to Mahabaleshwar. Our private taxis are ideal for weekend getaways, honeymoon trips, sightseeing tours, and family vacations."
  },
  {
    WhyChooseheading: "Wide Selection of Vehicles",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium cars to match your travel group and comfort preferences."
  },
  {
    WhyChooseheading: "One Way & Round Trip Cab Booking",
    WhyChoosedescription: "Whether you need a one-way transfer or a round-trip package with return on your preferred date, we provide flexible travel plans to suit your itinerary."
  },
  {
    WhyChooseheading: "Professional Chauffeurs for Hill Routes",
    WhyChoosedescription: "Our experienced drivers are familiar with the Mumbai to Mahabaleshwar route and ensure a safe, smooth, and enjoyable journey through the scenic Western Ghats."
  },
  {
    WhyChooseheading: "Customized Sightseeing Travel",
    WhyChoosedescription: "Plan your Mahabaleshwar holiday with optional sightseeing stops at Panchgani, Mapro Garden, Venna Lake, Arthur's Seat, Elephant's Head Point, and other popular attractions."
  },
  {
    WhyChooseheading: "Comfortable Long-Distance Journey",
    WhyChoosedescription: "Our regularly serviced vehicles feature spacious seating, clean interiors, and ample luggage space to make your road trip pleasant and relaxing."
  },
  {
    WhyChooseheading: "Easy Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Book your Mumbai to Mahabaleshwar cab quickly with transparent pricing, prompt customer support, and convenient pickup from your preferred location."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai to Mahabaleshwar Cab Service?",
    answer: "Yes, we offer comfortable Mumbai to Mahabaleshwar cab services for one-way, round-trip, and customized holiday travel."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Mahabaleshwar?",
    answer: "Yes, one-way taxi services are available for travellers who require direct transportation."
  },
  {
    question: "Which vehicles are available for this route?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Is the cab suitable for family vacations?",
    answer: "Yes, our spacious vehicles are ideal for families, couples, senior citizens, and groups visiting Mahabaleshwar."
  },
  {
    question: "Can I book a round-trip Mumbai to Mahabaleshwar taxi?",
    answer: "Yes, round-trip cab packages are available with flexible return schedules."
  },
  {
    question: "Can sightseeing be included in the trip?",
    answer: "Yes, you can customize your trip by including Panchgani, Venna Lake, Mapro Garden, and other sightseeing destinations."
  },
  {
    question: "Do you provide pickup from Mumbai Airport and hotels?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and other preferred locations."
  },
  {
    question: "Are tolls and parking charges included in the fare?",
    answer: "Tolls, parking fees, permits, and other applicable charges depend on the selected package and are shared during booking."
  },
  {
    question: "Is Mumbai to Mahabaleshwar cab service available every day?",
    answer: "Yes, Shreesha Tours & Travels provides cab booking assistance throughout the week based on availability."
  },
  {
    question: "How can I book a Mumbai to Mahabaleshwar Cab?",
    answer: "Simply share your travel date, pickup location, passenger details, preferred vehicle, and trip type to receive your quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Patil",
    feedback: "We booked a Mumbai to Mahabaleshwar cab with Shreesha Tours & Travels for a weekend getaway. The driver was professional, the car was spotless, and the hill journey was smooth and enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback: "Excellent service from booking to drop-off. The Innova Crysta was spacious, comfortable, and perfect for our family vacation. Highly recommended for Mahabaleshwar trips.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Mahabaleshwar Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-mahabaleshwar-cab.webp",
  "description":
    "Book Mumbai to Mahabaleshwar Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Mahabaleshwar with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for family vacations, weekend getaways, business travel, and sightseeing tours.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-mahabaleshwar-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Mumbai to Mahabaleshwar Cab | Scenic Taxi Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Mahabaleshwar Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable and comfortable travel from Mumbai to Mahabaleshwar with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Mahabaleshwar Cab, Mumbai to Mahabaleshwar Taxi, Mumbai to Mahabaleshwar Taxi Fare, Car from Mumbai to Mahabaleshwar, Cab Service from Mumbai to Mahabaleshwar, Cab Fare from Mumbai to Mahabaleshwar, Car Hire from Mumbai to Mahabaleshwar, Mumbai to Mahabaleshwar Cab Booking, Mumbai to Mahabaleshwar One Way Cab, Mumbai to Mahabaleshwar Round Trip Cab, Mumbai to Mahabaleshwar Car Rental, Mumbai to Mahabaleshwar Outstation Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default MumbaiToMahabaleshwarCab;